var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    stroke: "#0b75c2",
    d: "M8.22 3h7.56c1.889 0 2.863.264 3.41.85.489.522.74 1.406.79 2.974l.01.715V18.79c0 .625-.086 1.094-.217 1.419-.131.323-.292.468-.428.527-.133.058-.334.072-.631-.056-.264-.114-.58-.332-.935-.683l-.154-.16c-.504-.54-1.162-.808-1.824-.772a2.29 2.29 0 0 0-1.557.755l-.174.21-1.008 1.348c-.325.429-.716.604-1.067.604-.307 0-.644-.134-.941-.455l-.125-.15-1.01-1.347h.002c-.841-1.125-2.314-1.272-3.345-.385l-.19.181-.016.017-.006.007c-.414.444-.782.71-1.084.84-.296.127-.497.114-.63.056-.138-.06-.3-.205-.431-.528C4.086 19.893 4 19.424 4 18.8V7.54c0-2.022.248-3.091.808-3.69C5.356 3.265 6.33 3 8.22 3zm1.03 6.25C8.564 9.25 8 9.814 8 10.5s.564 1.25 1.25 1.25h5.5c.686 0 1.25-.564 1.25-1.25s-.564-1.25-1.25-1.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionMinus);
export default __webpack_public_path__ + "static/media/transaction-minus.095253b8b0062dfff82e21f2ac5abf87.svg";
export { ForwardRef as ReactComponent };